import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SimpleBar from "simplebar-react";

//import logo
import logoSm from "../assets/images/logo-small-screen.png";
import logoDark from "../assets/images/logo-dark.png";
import logoLight1 from "../assets/images/logo-light1.png";

//Import Components
import VerticalLayout from "./VerticalLayouts";
import { Container } from "reactstrap";
import HorizontalLayout from "./HorizontalLayout";
import Navdata from "./LayoutMenuData";

const Sidebar = ({ layoutType }) => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const verticalOverlay = document.getElementsByClassName("vertical-overlay");
    if (verticalOverlay) {
      verticalOverlay[0].addEventListener("click", function () {
        document.body.classList.remove("vertical-sidebar-enable");
      });
    }
  }, []);

  const addEventListenerOnSmHoverMenu = () => {
    if (
      document.documentElement.getAttribute("data-sidebar-size") === "sm-hover"
    ) {
      document.documentElement.setAttribute(
        "data-sidebar-size",
        "sm-hover-active"
      );
    } else if (
      document.documentElement.getAttribute("data-sidebar-size") === "sm-hover-active"
    ) {
      document.documentElement.setAttribute("data-sidebar-size", "sm-hover");
    } else {
      document.documentElement.setAttribute("data-sidebar-size", "sm-hover");
    }
  };

  return (
    <React.Fragment>
      <div className="app-menu navbar-menu custom-sidebar-bg">
        <div className="navbar-brand-box d-block">
          <Link to="/dashboard" className="logo logo-dark">
            <span className="logo-sm main-logo">
              <img
                src={
                  screenWidth >= 768 && screenWidth <= 1024
                    ? logoSm
                    : screenWidth < 768
                    ? logoLight
                    : logoSm
                }
                alt=""
                height="16"
                width="auto"
                className="img-fluid"
              />
            </span>
            <span className="logo-lg d-none d-lg-block">
              <img src={logoDark} alt="" height="25" width="auto" className="img-fluid" />
            </span>
          </Link>

          <Link to="/dashboard" className="logo logo-light">
            <span className="logo-sm  handle-logo ">
              <img
                src={
                  screenWidth >= 768 && screenWidth <= 1024
                    ? logoSm
                    : screenWidth < 768
                    ? logoLight
                    : logoSm
                }
                alt=""
                height="16"
                width="auto"
                className="img-fluid"
              />
            </span>
            <span className="logo-lg d-flex align-items-center" style={{height: "60px"}}>
              <img src={logoLight1} alt="" height="25" width="auto" className="img-fluid" />
            </span>
          </Link>

          <button
            onClick={addEventListenerOnSmHoverMenu}
            type="button"
            className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
            id="vertical-hover"
          >
            <i className="ri-record-circle-line"></i>
          </button>
        </div>

        {layoutType === "horizontal" ? (
          <div id="scrollbar" className="h-100">
            <Container fluid>
              <div id="two-column-menu"></div>
              <ul className="navbar-nav" id="navbar-nav">
                <HorizontalLayout />
              </ul>
            </Container>
          </div>
        ) : layoutType === "twocolumn" ? (
          <React.Fragment>
            {/* <TwoColumnLayout layoutType={layoutType} />
            <div className="sidebar-background"></div> */}
          </React.Fragment>
        ) : (
          <React.Fragment>
            <SimpleBar id="scrollbar" className="h-100">
              <Container fluid>
                <div id="two-column-menu"></div>
                <ul className="navbar-nav" id="navbar-nav">
                  <VerticalLayout layoutType={layoutType} />
                </ul>
              </Container>
            </SimpleBar>
            <div className="sidebar-background"></div>
          </React.Fragment>
        )}
      </div>

      <div className="vertical-overlay"></div>
    </React.Fragment>
  );
};

export default Sidebar;
